import { css } from '@emotion/core';
import { theme } from './theme';

export const getIconStrokeStyles = (color?: string) => css`
	svg {
		path {
			stroke: ${color || theme.color?.icon?.default};
		}
	}
`;
